var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sports_gymnastics_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 8.5C5.45 8.5 4.97917 8.30417 4.5875 7.9125C4.19583 7.52083 4 7.05 4 6.5C4 5.95 4.19583 5.47917 4.5875 5.0875C4.97917 4.69583 5.45 4.5 6 4.5C6.55 4.5 7.02083 4.69583 7.4125 5.0875C7.80417 5.47917 8 5.95 8 6.5C8 7.05 7.80417 7.52083 7.4125 7.9125C7.02083 8.30417 6.55 8.5 6 8.5ZM12.95 22.5C12.6833 22.5 12.4542 22.4083 12.2625 22.225C12.0708 22.0417 11.9667 21.8167 11.95 21.55L11.5 12.5L8 11.5H2C1.71667 11.5 1.47917 11.4042 1.2875 11.2125C1.09583 11.0208 1 10.7833 1 10.5C1 10.2167 1.09583 9.97917 1.2875 9.7875C1.47917 9.59583 1.71667 9.5 2 9.5H7L13.25 5.025C13.4667 4.875 13.7 4.81667 13.95 4.85C14.2 4.88333 14.4167 5 14.6 5.2C14.7833 5.43333 14.8583 5.6875 14.825 5.9625C14.7917 6.2375 14.6583 6.46667 14.425 6.65L11.15 9H14L21.15 4.875C21.3333 4.75833 21.5375 4.725 21.7625 4.775C21.9875 4.825 22.1917 4.95833 22.375 5.175C22.5583 5.375 22.6333 5.60417 22.6 5.8625C22.5667 6.12083 22.4417 6.33333 22.225 6.5L14.5 12.5L14.05 21.55C14.0333 21.8167 13.925 22.0417 13.725 22.225C13.525 22.4083 13.2667 22.5 12.95 22.5Z",
    fill: "#240b3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailSport);
export default __webpack_public_path__ + "static/media/retail-sport.2150dbe7875e588baa7667f4a7519dc0.svg";
export { ForwardRef as ReactComponent };